import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

/**
 * Commponent for password fields
 */
@Component({
  selector: '[app-form-field-password]',
  templateUrl: './form-field-password.component.html'
})
export class FormFieldPasswordComponent implements OnInit {
  @HostBinding('class.esf-form-item') public get formItemClass(): boolean {
    return true;
  }

  public passwordType: string = 'password';
  @Input() public id: string = 'password';
  @Input() public control: AbstractControl;
  @Input() public optional: boolean = false;
  @Input() public label: string = 'Password';
  @Input() public showOnFocus: boolean = false;
  constructor() { }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  public ngOnInit(): void {
    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  /**
   * Toggles the password.
   */
  public togglePassword(status?: boolean): void {
    if (this.passwordType === 'password') {
      this.passwordType = 'text';
    } else {
      this.passwordType = 'password';
    }
  }

  public setPassword(status: boolean) {
    this.passwordType = status ? 'text' : 'password';
  }
}
